import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  secondEmail: '',
  errors: {},
  isDisabled: false,
}

const editSecondaryEmailSlice = createSlice({
  name: 'editSecondaryEmail',
  initialState,
  reducers: {
    setSecondaryEmail: (state, action) => {
      state.secondEmail = action.payload
    }
  }
})

export const { setSecondaryEmail } = editSecondaryEmailSlice.actions

export default editSecondaryEmailSlice.reducer
